var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFooterFb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 227,
    viewBox: "0 0 208 227",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "FB"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M117.905 35.1311C78.948 34.6177 35.6791 65.261 32.6445 105.907C32.8988 130.616 50.2594 154.675 70.9043 167.482C148.036 205.565 254.168 47.9279 117.905 35.1311Z",
    fill: "#4686FF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ELEMENTS"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M120.895 104.122L122.527 93.6302H112.476V86.8105C112.476 83.9416 113.879 81.1384 118.366 81.1384H123V72.2039C120.301 71.7684 117.575 71.5328 114.842 71.499C106.57 71.499 101.169 76.5318 101.169 85.6302V93.6302H91.9999V104.122H101.169V129.499H112.476V104.122H120.895Z",
    fill: "white"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFb);
export default __webpack_public_path__ + "static/media/footer_fb.e531048b9501d1110e5ae7c960cb0043.svg";
export { ForwardRef as ReactComponent };